import React from "react";
import { Container, IconContainer, Text, Icon as IconStyle } from "./SideDrawerItem.css";
// Libraries
import { PropTypes } from "prop-types";
import {Link} from "react-router-dom";

const SideDrawerItem = ({ text, Icon, path }) => {
  return (
    <Link className={Container} to={path}>
      <div className={IconContainer}>
        <Icon className={IconStyle}/>
      </div>
      <h4 className={Text}>{text}</h4>
    </Link>
  );
};

SideDrawerItem.propTypes = {
  text: PropTypes.string.isRequired,
  Icon: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired,
};

export default SideDrawerItem;



// WEBPACK FOOTER //
// ./src/Components/Lists/SideDrawerList/SideDrawerItem.js